export const formatNumber = (value) => {
    return Number(value || 0).toLocaleString();
};